import { defineComponent as s, computed as p } from "vue";
import { JSONtoNaiveVars as i } from "./highrise343.mjs";
import { COMPONENT_NAME as l } from "./highrise178.mjs";
import { createDefaultTheme as m } from "./highrise350.mjs";
import f from "./highrise351.mjs";
const d = {
  titlePlacement: {
    type: String,
    default: "center"
  },
  dashed: {
    type: Boolean,
    default: !1
  },
  vertical: {
    type: Boolean,
    default: !1
  },
  marginTop: {
    type: Boolean,
    default: !0
  },
  marginBottom: {
    type: Boolean,
    default: !0
  },
  id: {
    type: String,
    default: void 0
  }
}, h = s({
  name: l.DIVIDER,
  components: {
    NDivider: f
  },
  props: d,
  slots: Object,
  setup(u, { attrs: e, slots: o, expose: a }) {
    a({});
    const n = p(() => i(m()));
    return {
      filteredAttrs: Object.keys(e).reduce(
        (r, t) => ((t === "class" || t.startsWith("data-")) && (r[t] = e[t]), r),
        {}
      ),
      slots: o,
      themeStyles: n
    };
  }
});
export {
  h as default
};
